<script>
</script>

<section>
    <div class="container">
        <div class="insight">
            <img
                src="/natalia-photo-optimised.webp"
                alt="Natalia Lysy the psychoterapist"
            />
        </div>
        <div class="text-container">
            <p>
                Jestem dyplomowaną psychoterapeutką psychodynamiczną w trakcie
                procesu certyfikacji. Ukończyłam czteroletnie szkolenie z
                psychoterapii psychodynamicznej w Krakowskim Centrum
                Psychodynamicznym akredytowanym przez Polskie Towarzystwo
                Psychologiczne i Polskie Towarzystwo Psychoterapii
                Psychodynamicznej. Ukończyłam pięcioletnie studia magisterskie
                na wydziale Nauk Społecznych na UPJPII w Krakowie oraz dwuletnie
                studium pedagogiczne. Odbyłam szkolenie z Mediacji Rodzinnej
                organizowane przez Stowarzyszenie Psychologiczno Pedagogiczne
                "Antidotum".
            </p>
            <p>
                Jestem członkinią Polskiego Towarzystwa Psychoterapii
                Psychodynamicznej.
            </p>
            <p>
                Swoje doświadczenie terapeutyczne zdobywałam pracując m. in. w
                Interwencji Kryzysowej gdzie udzielałam wsparcia
                pacjentom/klientom w sytuacjach nagłych/kryzysowych oraz
                prowadziłam psychoterapię osób dorosłych. Pracowałam w dwóch
                krakowskich szpitalach (Szpital Miejski Specjalistyczny im.
                Gabriela Narutowicza w Krakowie oraz Szpital Specjalistyczny im.
                Ludwika Rydygiera w Krakowie) na oddziałach
                ginekologiczno-położniczych, gdzie pracowałam z rodzicami w
                okresie okołoporodowym, pomagając im odnaleźć się w nowej
                sytuacji jaką jest pojawienie się dziecka. Staż psychiatryczny
                realizowałam na Psychiatrycznym Oddziale Dziennym Scanmed Psyche
                w Krakowie. Przez wiele lat pracowałam z rodzinami posiadającymi
                dziecko z niepełnosprawnością. Aktualnie łącze prywatną praktykę
                w gabinecie z pracą w Poradni Psychiatryczno - Psychologicznej w
                Krakowie, gdzie prowadzę psychoterapię psychodynamiczną osób
                dorosłych.
            </p>
            <p>
                Pracuję z osobami dorosłymi.
                Prowadzę psychoterapię indywidualną w nurcie psychodynamicznym.
            </p>
            <p>
                W gabinecie spotykam się z osobami, które doświadczają kryzysu
                życiowego, kryzysu tożsamości lub utraty. Z osobami które
                przeżywają trudności w życiu relacyjnym, zawodowym. Zajmuję się
                prowadzeniem terapii zaburzeń osobowości, zaburzeń
                psychosomatycznych, zaburzeń depresyjnych, zaburzeń lękowych i
                zaburzeń odżywiania. Przedmiotem moich zainteresowań jest
                również praca z kobietami w okresie okołoporodowym.
            </p>
            <p>
                Specjalizuję się głównie w pracy metodą TFP (terapia
                skoncentrowana na przeniesieniu).
            </p>
            <p>
                Regularnie poszerzam swój warsztat pracy poprzez udział w
                konferencjach i szkoleniach.
            </p>
            <p>Swoją pracę poddaję regularnej superwizji.</p>
        </div>
    </div>
</section>

<style>
    .container {
        display: flex;
        flex-direction: column;
        @media screen and (min-width: 1050px) {
            flex-direction: row;
        }
    }

    .text-container {
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        font-size: 0.7em;
        @media screen and (min-width: 1050px) {
            font-size: 1em;
        }
    }

    img {
        width: 100%;
    }

    .insight {
        margin: 21px;
        display: flex;
        flex: 1;
        align-items: flex-start;
    }

    p {
        width: 90%;
        font-size: 2.2em;
        @media screen and (min-width: 1050px) {
            font-size: 1.1em;
        }
    }
</style>
